// extracted by mini-css-extract-plugin
export default {"checkBox":"FilterCheckBox_checkBox__UXrB9","label":"FilterCheckBox_label__Py5wn"};